import * as d3 from 'd3';
import * as map from "../mapping.js";
import i18next from 'i18next';

import * as utilities from "../utilities.js";
import elements from '../elements/index.js';
import charts from "../charts/index.js";
import data_processing from "../data_processing/index.js";
// ====================================explanstion==============================================
let explanations = {
    "page3_sec1_title": "統計資料集各後設資料欄位填寫率。分母為資料集總數，分子為有填寫該欄位的資料集數量。比例經四捨五入到百分比個位數。",
    "page3_sec2_title": "統計資源各後設資料欄位填寫率。分母為資源總數，分子為有填寫該欄位的資源數量。比例經四捨五入到百分比個位數。",
};

let stats_data;
// ====================================file_path================================================

(async () => {
    try {
        await window.i18nReady;

        $('#languageSwitcher').on('change', function() {
            const selectedLang = $(this).val();
            i18next.changeLanguage(selectedLang, function(err, t) {
                // remove old popover
                document.querySelectorAll(".info_btn").forEach(el => el.remove());
                elements.info.gen_popover("h5.section_title", explanations);

                document.querySelectorAll(".card-title-dark").forEach(heading => {
                    let text = heading.textContent.trim();
                    let words = text.split(/\s+/);
                    if (selectedLang == "en" && words.length < 2) {
                        heading.innerHTML = `${text}</br></br>`;
                    }
                });
            });
        });

        // Popover
        elements.info.gen_popover("h5.section_title", explanations)

        // Obtain update_time
        const update_time = await data_processing.update_time.get_update_time();
        utilities.update_update_time_display(update_time);

        // Load the Daily Stats Data
        const update_month = update_time.slice(0,7);
        stats_data = await utilities.load_daily_stats_data(update_month);

        // ====================================page_elems===============================================
        let dataset_completeness = data_processing.number_of_data.gen_ratio_arr(stats_data[0], map.dataset_metadata_mapping, 'datasets');
        let resources_completeness = data_processing.number_of_data.gen_ratio_arr(stats_data[0], map.res_metadata_mapping, 'resources');

        charts.bar_chart.v_bar_chart_with_label('dataset_metadata', dataset_completeness);

        elements.cards.gen_cards_by_map("res_metadata", map.res_metadata_mapping);
        for (let field in map.res_metadata_mapping) {
            const cur_display_name = map.res_metadata_mapping[field];
            const id = `${field}_chart`;

            let cur_res_comp = {}
            for (let res of resources_completeness) {
                if(res['display_name'] == cur_display_name) {
                    cur_res_comp = res
                }
            }

            charts.pie_chart.simple_pie_chart(id, cur_res_comp);
        }

        elements.spinner.hideSpinner("loadingOverlay");
    } catch (error) {   
    }   
})();